export class TipoMoneda {

    static Dolar;
    static Peso;
    static Bitcoin;
    constructor() {
        TipoMoneda.Dolar = 1;
        TipoMoneda.Peso = 2;
        TipoMoneda.Bitcoin = 3;
    }
    get staticDolar(){
      return TipoMoneda.Dolar;
    }
    get staticPeso(){
      return TipoMoneda.Peso;
    }
    get staticBitcoin(){
      return TipoMoneda.Bitcoin;
    }

  }



// WEBPACK FOOTER //
// ./src/app/cliente/operaciones/tipoMoneda.model.ts